module.exports = __webpack_public_path__ + "static/media/10-tips-hiring-remote-software-developers.a0f4b81f.md";